import { IInitConfig } from 'flagsmith/types';

import { defaultFlags } from './defaultFlags';
import { Flags } from './flags';

const VITE_FLAGSMITH_API_URL =
  import.meta.env.VITE_FLAGSMITH_API_URL &&
  import.meta.env.VITE_FLAGSMITH_API_URL !== 'undefined'
    ? import.meta.env.VITE_FLAGSMITH_API_URL
    : 'https://flags.mm.ru/api/v1/';

const VITE_FLAGSMITH_ENV_ID =
  import.meta.env.VITE_FLAGSMITH_ENV_ID &&
  import.meta.env.VITE_FLAGSMITH_ENV_ID !== 'undefined'
    ? import.meta.env.VITE_FLAGSMITH_ENV_ID
    : 'HafwokRngHk3ufWAdsS3iK';

export const flagsmithConfig: IInitConfig<Flags> = {
  api: VITE_FLAGSMITH_API_URL,
  environmentID: VITE_FLAGSMITH_ENV_ID,
  preventFetch: true,
  defaultFlags,
};
